module.exports = __webpack_public_path__ + "img/zemIcon.2f3f68a4.png";